import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { ICategoryContext, CategoryContext } from '../../../../categoryState/categoryContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { categories } = useContext<ICategoryContext>(CategoryContext);

	const categoryHeadingClasses = classNames(style.category, style.heading);
	const categoryTypeHeadingClasses = classNames(style.categoryType, style.heading);
	const positionHeadingClasses = classNames(style.position, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryTypeHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryTypeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={positionHeadingClasses}
					translationNameSpace="listing"
					translationKey="positionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{categories.categories.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};

export default List;
